/**
 * Business WhatsApp (digits only: country code + national number, no "+" or spaces).
 */
export const WHATSAPP_BUSINESS_E164 = "919033412974";

export function openWhatsAppWithMessage(message) {
  const text = message == null ? "" : String(message);
  window.open(
    `https://wa.me/${WHATSAPP_BUSINESS_E164}?text=${encodeURIComponent(text)}`,
    "_blank",
    "noopener,noreferrer"
  );
}

/**
 * PDP / product-aware inquiry opener.
 */
export function openWhatsAppProductInquiry({
  productName,
  productPageUrl,
  productId,
}) {
  const name = productName?.trim?.() ? productName.trim() : "this product";
  let msg = `Hi! I'd like to know more about:\n${name}`;
  if (productPageUrl) {
    msg += `\n${productPageUrl}`;
  }
  if (productId != null && String(productId).trim() !== "") {
    msg += `\n(Product ID: ${productId})`;
  }
  msg += `\nPlease share availability, sizes, and pricing.`;
  openWhatsAppWithMessage(msg);
}
